import { render, staticRenderFns } from "./CrossCheckStage.vue?vue&type=template&id=6673cbef&scoped=true&"
import script from "./CrossCheckStage.vue?vue&type=script&lang=ts&"
export * from "./CrossCheckStage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6673cbef",
  null
  
)

export default component.exports